import { Component, EventEmitter, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AutenticacaoConfiguracaoLicencaService, DialogService } from 'app/services';

@Component({
  selector: 'app-dialog-login',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './dialog-login.component.html',
  styleUrl: './dialog-login.component.css'
})
export class DialogLoginComponent {
  @Output() fechar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() trocarTela: EventEmitter<string> = new EventEmitter<string>();
  public loginInvalido: boolean = false;
  public mostrarSenha: boolean = false;

  constructor(
    private autenticacaoConfiguracaoLicencaService: AutenticacaoConfiguracaoLicencaService,
    private dialogService: DialogService,
  ) { }

  public validarCredenciais(login: string, senha: string): void {
    if (!login || !senha) {
      this.mostrarMensagemErro();
      this.loginInvalido = true;
      return;
    };

    const credenciaisValidas: boolean = this.autenticacaoConfiguracaoLicencaService.login(login, senha);

    if (!credenciaisValidas) {
      this.mostrarMensagemErro();
      this.loginInvalido = true;
      return;
    }

    this.trocarTela.emit('configuracoes/licenca');
  }

  public mostrarMensagemErro(): void {
    this.dialogService.erroTemporario('Credenciais inválidas', 'Login ou senha inválido(a).');
  }

  public fecharDialog(irParaTelaDeLicenca: boolean = false): void {
    this.fechar.emit(irParaTelaDeLicenca);
  }
}
